import { client } from '../api/client.js';

const _CMD_ICONS = {
  'home': '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>',
  'sparkles': '<path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5L12 3z"/><path d="M5 19l.5 1.5L7 21l-1.5.5L5 23l-.5-1.5L3 21l1.5-.5L5 19z"/>',
  'book-open': '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>',
  'clipboard': '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>',
  'calendar': '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  'bar-chart': '<line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/>',
  'brain': '<path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 4.44-2.04z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-4.44-2.04z"/>',
  'settings': '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
  'edit': '<path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>',
  'rocket': '<path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>',
  'sun-moon': '<path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="M4.93 4.93l1.41 1.41"/><path d="M17.66 17.66l1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="M6.34 17.66l-1.41 1.41"/><path d="M19.07 4.93l-1.41 1.41"/>',
  'file-text': '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>',
  'target': '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>',
  'camera': '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>',
  'square': '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>',
  'briefcase': '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>',
  'music': '<path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>',
  'search': '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
  'help-circle': '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
  'shield': '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
};

function cmdIcon(name, w = 16, h = 16) {
  return `<svg width="${w}" height="${h}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">${_CMD_ICONS[name] || ''}</svg>`;
}

const QUICK_ACTIONS_BASE = [
  { icon: cmdIcon('sparkles'), label: 'Generate Post', desc: 'Create AI-powered social content', hint: '\u2192 Studio', run() { window.location.hash = '#create'; } },
  { icon: cmdIcon('rocket'), label: 'New Campaign', desc: 'Plan a multi-platform content campaign', hint: '\u2192 Campaigns', run() { window.location.hash = '#campaigns'; } },
  { icon: cmdIcon('calendar'), label: 'Schedule Content', desc: 'View and manage your content calendar', hint: '\u2192 Calendar', run() { window.location.hash = '#calendar'; } },
  { icon: cmdIcon('sun-moon'), label: 'Toggle Theme', desc: 'Switch between dark and light mode', run() { const b = document.getElementById('theme-toggle'); if (b) b.click(); } },
];

// Setup-related deep links \u2014 surfaced as a dedicated group so the most
// common "where do I add a key / connect Claude / restart the tour" tasks
// are a Cmd-K query away. The "Resume setup wizard" entry only appears
// when the wizard hasn't been completed yet.
const SETUP_ACTIONS_BASE = [
  { icon: cmdIcon('settings', 14, 14), label: 'Add an AI API key', desc: 'Open Settings \u2192 AI provider keys', hint: '\u2192 Settings', run() { window.location.hash = '#settings?section=section-ai-settings'; } },
  { icon: cmdIcon('briefcase', 14, 14), label: 'Connect Claude Desktop or ChatGPT', desc: 'Set up the MCP connector', hint: '\u2192 Connectors', run() { window.location.hash = '#connectors'; } },
  { icon: cmdIcon('help-circle', 14, 14), label: 'Restart site tour', desc: 'Re-run the spotlight tour through the app', run() { window.location.hash = window.location.hash.includes('?') ? window.location.hash + '&tour=1' : (window.location.hash || '#home') + '?tour=1'; } },
];

function getSetupActions() {
  const items = SETUP_ACTIONS_BASE.slice();
  const u = window.__auth__ || {};
  if (u && u.id && !u.onboarding_completed) {
    items.push({
      icon: cmdIcon('rocket', 14, 14),
      label: 'Resume setup wizard',
      desc: 'Pick up where you left off',
      run() { window.location.hash = window.location.hash.includes('?') ? window.location.hash + '&setup=1' : (window.location.hash || '#home') + '?setup=1'; }
    });
  }
  return items;
}

// Conditional quick actions \u2014 composed at render time so they only surface
// when the underlying affordance is actually available to this user.
function getQuickActions() {
  const actions = [...QUICK_ACTIONS_BASE];
  // Phase 35-D: "Switch Brand" \u2014 only show if the workspace switcher is
  // actually interactive (chevron visible). Triggers the same popover the
  // sidebar lockup opens.
  const chevron = document.getElementById('workspace-switcher-chevron');
  if (chevron && !chevron.hidden) {
    actions.push({
      icon: cmdIcon('briefcase'),
      label: 'Switch Brand',
      desc: 'Open the workspace switcher',
      hint: '\u2192 Sidebar',
      run() { document.getElementById('workspace-switcher-trigger')?.click(); }
    });
  }
  return actions;
}

// Static nav items always shown to every authenticated user.
const NAV_ITEMS_BASE = [
  { icon: cmdIcon('home', 12, 12), label: 'Home', run() { window.location.hash = '#home'; } },
  { icon: cmdIcon('sparkles', 12, 12), label: 'Content Studio', run() { window.location.hash = '#create'; } },
  { icon: cmdIcon('book-open', 12, 12), label: 'Library', run() { window.location.hash = '#library'; } },
  { icon: cmdIcon('clipboard', 12, 12), label: 'Campaigns', run() { window.location.hash = '#campaigns'; } },
  { icon: cmdIcon('calendar', 12, 12), label: 'Calendar', run() { window.location.hash = '#calendar'; } },
  { icon: cmdIcon('bar-chart', 12, 12), label: 'Analytics', run() { window.location.hash = '#analytics'; } },
  { icon: cmdIcon('brain', 12, 12), label: 'Brain', run() { window.location.hash = '#memory'; } },
  { icon: cmdIcon('settings', 12, 12), label: 'Settings', run() { window.location.hash = '#settings'; } },
  { icon: cmdIcon('help-circle', 12, 12), label: 'Help', run() { window.location.hash = '#help'; } },
];
// Conditional nav items — composed at render time so role/tier changes show up live.
function getNavItems() {
  const items = [...NAV_ITEMS_BASE];
  const u = window.__auth__ || {};
  // Agent Inbox is gated to Pro+ tier (matches sidebar visibility logic).
  const proTiers = ['pro', 'business', 'founder', 'agency'];
  const adminRoles = ['admin', 'angel_admin', 'god_admin'];
  if (adminRoles.includes(u.role) || proTiers.includes(u.tier)) {
    items.splice(7, 0, { icon: cmdIcon('clipboard', 12, 12), label: 'Agent Inbox', run() { window.location.hash = '#agent-inbox'; } });
  }
  if (adminRoles.includes(u.role)) {
    items.push({ icon: cmdIcon('shield', 12, 12), label: 'Admin', run() { window.location.hash = '#admin'; } });
  }
  return items;
}

const PLATFORM_ICONS = {
  twitter: '\uD835\uDD4F', x: '\uD835\uDD4F',
  instagram: cmdIcon('camera'), facebook: cmdIcon('square'), linkedin: cmdIcon('briefcase'), tiktok: cmdIcon('music'),
};

const STATUS_LABELS = {
  draft: 'Draft', published: 'Published', scheduled: 'Scheduled', failed: 'Failed',
  active: 'Active', completed: 'Completed', paused: 'Paused',
};

let focusIdx = -1;
let searchResults = null;
let debounceTimer = null;
let isSearching = false;

export function initCommandPalette() {
  const overlay = document.getElementById('cmd-palette');
  const inp = document.getElementById('cmd-input');
  const res = document.getElementById('cmd-results');
  if (!overlay || !inp || !res) {
    console.warn('[CMD_PALETTE] Missing DOM elements:', { overlay: !!overlay, inp: !!inp, res: !!res });
    return;
  }

  function getAllItems() {
    const items = [];
    const q = inp.value.trim().toLowerCase();

    if (!q) {
      // Default view: Setup + Quick Actions + Nav Items
      getSetupActions().forEach(c => items.push({ ...c, _type: 'setup', s: 'Setup' }));
      getQuickActions().forEach(c => items.push({ ...c, _type: 'quick-action', s: 'Quick Actions' }));
      getNavItems().forEach(c => items.push({ ...c, _type: 'nav', s: 'Navigate' }));
      return items;
    }

    // When searching: show API results first, then matching commands
    if (searchResults) {
      appendSearchResults(items);
    }

    // Filter setup, quick actions and nav items by query
    const allCommands = [
      ...getSetupActions().map(c => ({ ...c, _type: 'setup', s: 'Setup' })),
      ...getQuickActions().map(c => ({ ...c, _type: 'quick-action', s: 'Quick Actions' })),
      ...getNavItems().map(c => ({ ...c, _type: 'nav', s: 'Navigate' })),
    ];
    const filtered = allCommands.filter(c => c.label.toLowerCase().includes(q) || (c.desc && c.desc.toLowerCase().includes(q)));
    filtered.forEach(c => items.push(c));

    return items;
  }

  function appendSearchResults(items) {
    const { posts, campaigns, facts } = searchResults;
    if (posts?.length) {
      posts.forEach(p => {
        const platformLabel = p.platform ? (p.platform === 'x' ? 'X' : p.platform.charAt(0).toUpperCase() + p.platform.slice(1)) : '';
        const contentText = p.content || p.preview || '';
        const preview = contentText ? contentText.substring(0, 80).trim() + (contentText.length > 80 ? '\u2026' : '') : '';
        items.push({
          s: 'Content', _type: 'post',
          icon: PLATFORM_ICONS[p.platform] || cmdIcon('file-text'),
          label: p.title || preview || `${platformLabel} post`,
          desc: p.title ? preview : '',
          hint: `${platformLabel} \u00b7 ${STATUS_LABELS[p.status] || p.status || ''}`,
          run() { window.location.hash = `#library?highlight=${p.id}`; }
        });
      });
    }
    if (campaigns?.length) {
      campaigns.forEach(c => items.push({
        s: 'Campaigns', _type: 'campaign',
        icon: cmdIcon('target'),
        label: c.name,
        desc: c.goal ? c.goal.substring(0, 80) : '',
        hint: STATUS_LABELS[c.status] || c.status || '',
        run() { window.location.hash = `#campaigns?id=${c.id}`; }
      }));
    }
    if (facts?.length) {
      facts.forEach(f => items.push({
        s: 'Brain', _type: 'fact',
        icon: cmdIcon('brain'),
        label: f.content.length > 60 ? f.content.slice(0, 57) + '\u2026' : f.content,
        hint: f.type || '',
        run() { window.location.hash = '#memory'; }
      }));
    }
  }

  function render() {
    const items = getAllItems();
    const q = inp.value.trim();

    let html = '';

    // Show loading indicator while searching
    if (isSearching && q.length >= 2) {
      html += `<div class="cmd-empty">Searching\u2026</div>`;
    }

    if (!items.length && q) {
      res.innerHTML = html + `<div class="cmd-empty">No results for \u201C${q.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}\u201D</div>`;
      return;
    }

    if (!q) {
      // Default view: Setup, Quick Actions as vertical lists, Nav as pills
      const setupActions = getSetupActions();
      let runningIdx = 0;
      if (setupActions.length) {
        html += `<div class="cmd-section-label">Setup</div>`;
        setupActions.forEach((c) => {
          const i = runningIdx++;
          html += `<div class="cmd-result-item${i === focusIdx ? ' focused' : ''}" data-index="${i}">
            <span class="cmd-result-icon">${c.icon}</span>
            <div style="flex:1"><div class="cmd-result-label">${c.label}</div>${c.desc ? `<div class="cmd-result-hint">${c.desc}</div>` : ''}</div>
            ${c.hint ? `<span class="cmd-result-hint">${c.hint}</span>` : ''}
          </div>`;
        });
      }

      html += `<div class="cmd-section-label">Quick Actions</div>`;
      const quickActions = getQuickActions();
      quickActions.forEach((c) => {
        const i = runningIdx++;
        html += `<div class="cmd-result-item${i === focusIdx ? ' focused' : ''}" data-index="${i}">
          <span class="cmd-result-icon">${c.icon}</span>
          <div style="flex:1"><div class="cmd-result-label">${c.label}</div>${c.desc ? `<div class="cmd-result-hint">${c.desc}</div>` : ''}</div>
          ${c.hint ? `<span class="cmd-result-hint">${c.hint}</span>` : ''}
        </div>`;
      });

      const navOffset = runningIdx;
      const navItems = getNavItems();
      html += `<div class="cmd-section-label">Navigate</div>`;
      html += `<div class="cmd-nav-pills">`;
      navItems.forEach((c, i) => {
        html += `<div class="cmd-nav-pill${(i + navOffset) === focusIdx ? ' focused' : ''}" data-index="${i + navOffset}">${c.icon} ${c.label}</div>`;
      });
      html += `</div>`;
    } else {
      // Search results view: grouped by section
      let lastSection = '';
      items.forEach((c, i) => {
        if (c.s !== lastSection) {
          lastSection = c.s;
          html += `<div class="cmd-section-label">${c.s}</div>`;
        }
        if (c._type === 'nav') {
          // Render nav items as pills even in search results
          if (c.s !== lastSection || !html.includes('cmd-nav-pills')) {
            // Group consecutive nav items into pills
          }
          html += `<div class="cmd-result-item${i === focusIdx ? ' focused' : ''}" data-index="${i}">
            <span class="cmd-result-icon">${c.icon}</span>
            <span class="cmd-result-label">${c.label}</span>
            ${c.hint ? `<span class="cmd-result-hint">${c.hint}</span>` : ''}
          </div>`;
        } else {
          html += `<div class="cmd-result-item${i === focusIdx ? ' focused' : ''}" data-index="${i}">
            <span class="cmd-result-icon">${c.icon}</span>
            <div style="flex:1"><div class="cmd-result-label">${c.label}</div>${c.desc ? `<div class="cmd-result-hint">${c.desc}</div>` : ''}</div>
            ${c.hint ? `<span class="cmd-result-hint">${c.hint}</span>` : ''}
          </div>`;
        }
      });
    }

    res.innerHTML = html;
    const f = res.querySelector('.focused');
    if (f) f.scrollIntoView({ block: 'nearest' });
  }

  function open() {
    overlay.hidden = false;
    focusIdx = 0;
    inp.value = '';
    searchResults = null;
    isSearching = false;
    render();
    setTimeout(() => inp.focus(), 10);
  }

  function close() {
    overlay.hidden = true;
    focusIdx = -1;
    searchResults = null;
    isSearching = false;
    if (debounceTimer) clearTimeout(debounceTimer);
  }

  function exec() {
    const items = getAllItems();
    if (focusIdx >= 0 && focusIdx < items.length) {
      const cmd = items[focusIdx];
      close();
      cmd.run();
    }
  }

  async function doSearch(q) {
    if (!q || q.length < 2 || !window.__auth__) {
      searchResults = null;
      isSearching = false;
      render();
      return;
    }
    isSearching = true;
    render();
    try {
      const { results } = await client.search(q);
      searchResults = results;
    } catch (e) {
      searchResults = null;
    }
    isSearching = false;
    render();
  }

  // Keyboard shortcut
  document.addEventListener('keydown', (e) => {
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      overlay.hidden ? open() : close();
    }
  });

  // Overlay click to close
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });

  // Close button (X)
  const closeBtn = document.getElementById('cmd-close-btn');
  if (closeBtn) closeBtn.addEventListener('click', close);

  // Input handling
  inp.addEventListener('input', () => {
    const q = inp.value.trim();
    focusIdx = 0;
    render();

    // Debounce API search
    if (debounceTimer) clearTimeout(debounceTimer);
    if (q.length >= 2) {
      debounceTimer = setTimeout(() => doSearch(q), 200);
    } else {
      searchResults = null;
      isSearching = false;
      render();
    }
  });

  inp.addEventListener('keydown', (e) => {
    const items = getAllItems();
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); focusIdx = Math.min(focusIdx + 1, items.length - 1); render(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); focusIdx = Math.max(focusIdx - 1, 0); render(); }
    else if (e.key === 'Enter') { e.preventDefault(); exec(); }
  });

  // Click result items (both .cmd-result-item and .cmd-nav-pill)
  res.addEventListener('click', (e) => {
    const el = e.target.closest('.cmd-result-item') || e.target.closest('.cmd-nav-pill');
    if (!el) return;
    focusIdx = parseInt(el.dataset.index, 10);
    exec();
  });

  // Wire topbar search button directly
  const searchBtn = document.getElementById('topbar-search-btn') || document.querySelector('.topbar-search-btn');
  if (searchBtn) {
    searchBtn.addEventListener('click', () => {
      overlay.hidden ? open() : close();
    });
  }

  // Expose open for programmatic use
  window.__openCommandPalette = open;
}
